/* Site events for the ROI calculator funnel:
   calculator_started, calculator_result_shown, lead_form_submitted,
   phone_click.

   Consent comes from the cookie banner's stored choice (assets/cookie-banner.js,
   localStorage "ir_cookie_consent"):
   - dataLayer push: only with analytics consent. Each event also carries
     consent_analytics / consent_marketing so a future GTM container can
     gate its own tags.
   - gtag (Google Ads, AW-…): only with marketing consent.
   There is no Meta pixel (fbq) in the theme; Meta events would come from the
   Facebook & Instagram app's own pixel, configured in Shopify.
   Without a stored choice nothing is sent. */
(function () {
  var CONSENT_KEY = 'ir_cookie_consent';
  var lastCalc = null;

  function consent() {
    try {
      var raw = window.localStorage.getItem(CONSENT_KEY);
      var c = raw ? JSON.parse(raw) : null;
      return { analytics: !!(c && c.analytics), marketing: !!(c && c.marketing) };
    } catch (e) {
      return { analytics: false, marketing: false };
    }
  }

  // Calculator inputs as flat event parameters (no personal data).
  function calcParams() {
    if (!lastCalc) return {};
    return {
      robot: lastCalc.robot_name,
      robot_id: lastCalc.robot_id,
      financing_type: lastCalc.financing_type,
      area_sqm: lastCalc.area_sqm,
      facility_type: lastCalc.facility_type,
      cleaning_frequency: lastCalc.cleaning_frequency,
      dynamic_environment: lastCalc.dynamic_environment,
      robot_count: lastCalc.robot_count,
      payback_months: lastCalc.payback_months,
      monthly_saving: lastCalc.monthly_saving,
      annual_saving: lastCalc.annual_saving,
    };
  }

  function track(name, params) {
    var c = consent();
    var data = {};
    var k;
    params = params || {};
    for (k in params) {
      if (params[k] !== null && params[k] !== undefined && params[k] !== '') data[k] = params[k];
    }
    data.page_path = window.location.pathname;

    if (c.analytics) {
      window.dataLayer = window.dataLayer || [];
      var push = { event: name, consent_analytics: c.analytics, consent_marketing: c.marketing };
      for (k in data) push[k] = data[k];
      window.dataLayer.push(push);
    }

    if (!c.marketing) return;

    if (typeof window.gtag === 'function') {
      var gtagParams = { transport_type: 'beacon' };
      for (k in data) gtagParams[k] = data[k];
      window.gtag('event', name, gtagParams);
    }
  }

  document.addEventListener('grp:start', function (e) {
    track('calculator_started', { first_field: e.detail && e.detail.field });
  });

  document.addEventListener('grp:result', function (e) {
    lastCalc = e.detail || null;
    track('calculator_result_shown', calcParams());
  });

  document.addEventListener('grp:reset', function () {
    lastCalc = null;
  });

  // Counted when the form is valid (required name/phone/privacy checkbox).
  // Not keyed on defaultPrevented: Shopify's contact-form captcha cancels
  // every submit and re-sends the form itself. The flag stops a re-dispatched
  // submit from counting twice.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/contact"]')) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    if (form.__irLeadTracked) return;
    form.__irLeadTracked = true;
    window.setTimeout(function () {
      form.__irLeadTracked = false;
    }, 5000);

    var params = calcParams();
    params.form_location = form.closest('#cta-kontakt') ? 'cta_kontakt' : 'contact_form';
    params.has_calculation = !!lastCalc;
    track('lead_form_submitted', params);
  });

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href^="tel:"]') : null;
    if (!link) return;

    var section = link.closest('[data-ir-track-location], #cta-kontakt, header, footer, section');
    var location = '';
    if (section) {
      location =
        section.getAttribute('data-ir-track-location') ||
        section.id ||
        section.tagName.toLowerCase();
    }

    var params = calcParams();
    params.phone_number = link.getAttribute('href').replace(/^tel:/, '');
    params.link_location = location;
    track('phone_click', params);
  });
})();
